<div class="page-wrapper" id="page-wrapper" [ngClass]="{ haptic: this.config.modalities[0].active }">
  <div class="page-section start" [ngClass]="{ darkMode: this.config.theme === 'dark-mode' }">

    <!-- <div class="svgBg" style="background-image: url('../../../assets/images/test-image-main2.svg')"></div> -->

    <div class="vertical-aligned-textblock">
      <h1>{{ this.data?.header }}</h1>
      <p class="basic-text-style-large">{{ this.data?.intro_text }}</p>
      <span class="site-explanation">{{ this.data?.explanation }}
        <!-- <div class="arrow-link explanation"></div> -->
      </span>
    </div>

    <div class="mobile-multimodal-menu-front-page" [ngClass]="{ darkMode: this.config.theme === 'dark-mode' }">
      <app-multimodal></app-multimodal>
    </div>

    <div id="svgBg"></div>

    <div class="scroll-down-image buttonEl" [ngClass]="{ darkMode: this.config.theme === 'dark-mode', visual: this.config.modalities[1].active }" id="scroll-msg"
    [attr.data-text]="this.data?.scrolldown_text" [inlineSVG]="'/assets/images/scroll-down.svg'" title="{{ this.data?.scrolldown_text }}" (click)="scrollDown();"></div>
  </div>


  <div class="page-section selected-work" id="selected-work" [ngClass]="{ darkMode: this.config.theme === 'dark-mode', haptic: this.config.modalities[0].active }">
    <div class="section-title"><p class="section-title-text-style">Selected projects</p></div>

    <div class="selected-projects" *ngFor="let project of this.data?.selected_work" [ngClass]="{ haptic: this.config.modalities[0].active }">

      <div class="video-preview column">
        <div class="video-wrapper">
          <video #video width="100%" height="auto" [muted]="true" class="video" id="video" controls>
              <source src="{{ project?.video }}" type="video/mp4">
          </video>
        </div>
      </div>
      <div class="project-details column">
        <p class="project-title">{{ project?.title }}</p>
        <p class="project-details basic-text-style-large">{{ project?.description }}</p>
      </div>

    </div>
  </div>
  <app-footer></app-footer>
</div>
